var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("entry-message-sent-date", {
        attrs: { date: _vm.date, "is-read": _vm.isRead },
      }),
      _vm._v(" "),
      _c("entry-message-subject", { attrs: { subject: _vm.subject } }),
      _vm._v(" "),
      _c("entry-message-body", {
        attrs: { body: _vm.body, "is-remind-mail": _vm.isRemindMail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }